<template>
   <div class="leftBox1">
    <router-link :to="{path:'/'+pathName}">
          <div class="title1">
            <img src="@/assets/img/plant/leftCircle.png" class="leftCircle" />
            {{title}}
            <div class="line1"></div>
            <img src="@/assets/img/jiantou2.gif" v-if="isImg" />
          </div>
          </router-link>
          <div class="leftContent">
            <div class="contentLine contentLine1"></div>
            <div class="contentLine contentLine2"></div>
            <div class="contentLine contentLine3"></div>
            <div class="contentLine contentLine4"></div>
            <slot></slot>
          </div>
        </div>
</template>
<script>
import { ref, onMounted } from "vue";

export default {
  name: "baseBar",
  props: ["title","isImg","pathName"],

  setup(props) {
    
    onMounted(() => {
    //  console.log(props)
      
    });
    return {
      
    };
  },
};

</script>
<style lang="less" scoped>
.leftBox1{margin-bottom: 10px;}
      .title1{
      width: 100%;
      height: 55px;
      background: url("../../assets/img/plant/conTit.png") no-repeat top center;
      background-size: 100% 100%;
      line-height: 45px;
      padding-left: 60px;
      text-align: left;
      font-size: 18px;
      color: #fff;
      position: relative;
      display: flex;
      justify-content: space-between;
      .line1{
        position: absolute;
        bottom: 15px;
        width: 100px;
        height: 1px;
        background-image: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(19,204,176,0.8) 50%, rgba(255,255,255,0) 100%);
        animation: infoLine 2s linear infinite;
      //  box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.8);
      }
      .leftCircle{
        position: absolute;
        width: 44px;
        height: 44px;
        left: 0;
        top: 1px;
        animation: guangying 2s linear infinite;
      }
      img{
        height: 16px;
        margin-right: 30px;
      }
    }
    .leftContent{
        width: 503px;
        // height: 250px;
        background: url("../../assets/img/plant/left1Bg.png") no-repeat top center;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        margin-top: -10px;

      }
    .contentLine {
      background: #AA6A1C;
      position: absolute;
    }
    .contentLine1{
      top: 0;
      left: 0;
      width: 20%;
      height: 2px;
      /* 加上渐变效果，方可形成拖尾效果 */
      background: linear-gradient(90deg, transparent, #1AA19E);
      animation: animate1 4s linear infinite;
    }
    .contentLine2{
      top: -100%;
      right: 1px;
      width: 2px;
      height: 20%;
      background: linear-gradient(180deg, transparent, #AA6A1C);
      animation: animate2 4s linear infinite;
      /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
      animation-delay: 1s;
    }
    .contentLine3{
      bottom: 0;
      right: 0;
      width: 20%;
      background: linear-gradient(270deg, transparent, #1AA19E);
      animation: animate3 4s linear infinite;
      animation-delay: 2s;
    }
    .contentLine4{
      bottom: -100%;
      left: 2px;
      width: 2px;
      height: 20%;
      background: linear-gradient(360deg, transparent, #AA6A1C);
      animation: animate4 4s linear infinite;
      animation-delay: 3s;
    }
    /* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(-360deg);
  }
}

@keyframes animate1 {
    0% {
        left: -50%;
    }

    50%,
    100% {
        left: 100%;
    }
}

@keyframes animate2 {
    0% {
        top: -100%;
    }

    50%,
    100% {
        top: 100%;
    }
}
@keyframes animate3 {
    0% {
        right: -100%;
        height: 3px;
    }

    50%,
    100% {
        height: 2px;
        right: 100%;
    }
}
 @keyframes animate4 {
    0% {
        bottom: -100%;
    }

    50%,
    100% {
        bottom: 100%;
    }
}
</style>
